import {DomainAncestor, entityConfig} from "core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {IDomainObject} from "core/form/formUtils";
import {ID} from "core/metamodel/metaConstant";
import {LovItem} from "core/metamodel/mdEntity";



@entityConfig()
export class GridSpecialCondition extends DomainAncestor {

  @observable specialConditionId: number;
  @observable gridLocation: string;
  @observable name: string;
  @observable description: string;
  @observable sql: string;

  @observable gridConfigs: LovItem[];

  constructor(json: IDomainObject) {
    super(json);

    if (!this.gridConfigs) this.gridConfigs = [];
  }


  public getId(): ID {
    return this.specialConditionId;
  }

  public setId(id: ID): void {
    this.specialConditionId = <any>id;
  }

}



// WEBPACK FOOTER //
// ./src/core/grid/domain/gridSpecialCondition.ts